module.exports = __webpack_public_path__ + "img/fornecedores.496e9f1e.png";